module.exports = __webpack_public_path__ + "img/item4.1ac812ae.png";